"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'user.profile.title': '编辑个人资料',
    'user.profile.back': '返回仪表板',
    'user.profile.name.label': '全名',
    'user.profile.name.placeholder': '张三',
    'user.profile.username.label': '用户名',
    'user.profile.username.placeholder': 'zhangsan',
    'user.profile.email.label': '电子邮件',
    'user.profile.email.placeholder': 'email@address.com',
    'user.profile.picture.label': '头像',
    'user.profile.picture.placeholder': '选择头像...',
    'user.profile.picture.remove': '×',
    'user.profile.changePassword.title': '更改密码',
    'user.profile.changePassword.description': '如果不想更改密码，请将密码字段留空。',
    'user.profile.password.new.label': '新密码',
    'user.profile.password.placeholder': '输入新密码',
    'user.profile.password.repeat.label': '重复新密码',
    'user.profile.password.repeat.placeholder': '重复新密码',
    'user.profile.submit': '更新个人资料',
    'user.profile.form.passwordMismatch': '密码不匹配',
    'user.profile.form.updateFailed': '更新个人资料失败',
    'user.profile.form.updateSuccess': '个人资料更新成功',
};
